
const environmentUrls = {
    local: "localhost",
    local4502: "localhost:4502",
    test: "test.nuskin.com",
    testAuthor: "testauthor.nuskin.com",
    testStorefront: "test.mynuskin.com",
    testCloud: "tst.nuskin.io",
    dev: "dev.nuskin.com",
    devAuthor: "devauthor.nuskin.com",
    devCloud: "dev.nuskin.io",
    prod: "www.nuskin.com",
    prodAuthor: "author.nuskin.com",
    prodStorefront: ".mynuskin.com",
    prodCloud: "www.nuskin.io",
    prodPubServer: "prd-pubaws-aem",
    stage: "stage.nuskin.com",
    stageAuthor: "stageAuthor.nuskin.com",
    stageCloud: "stg.nuskin.io",
    feature: "dev.usw2.nuskin.io"
};

/**
   * Dev Environment URLs
   */
const devEnvironmentUrls = [
    environmentUrls.dev,
    environmentUrls.devCloud,
    environmentUrls.devAuthor
];

/**
   * Test Environment URLs
   */
const testEnvironmentUrls = [
    environmentUrls.test,
    environmentUrls.testAuthor,
    environmentUrls.testStorefront,
    environmentUrls.feature,
    environmentUrls.testCloud,
    environmentUrls.local,
    environmentUrls.local4502
];

/**
   * Stage Environment URLs
   */
const stageEnvironmentUrls = [
    environmentUrls.stage,
    environmentUrls.stageAuthor,
    environmentUrls.stageCloud
];

/**
   * Prod Environment URLs
   */
const prodEnvironmentUrls = [
    environmentUrls.prod,
    environmentUrls.prodAuthor,
    environmentUrls.prodCloud,
    environmentUrls.prodStorefront
];

const checkForUrl = () => {
    return (typeof window !== 'undefined' && window && window.location && window.location.href);
};

const getEnvironmentCode = () => {
    let envCode = process && process.env && process.env.NODE_ENV;
    envCode = envCode === 'production' ? 'prod' : envCode;

    if (checkForUrl()) {
        const url = window.location.href;

        if (devEnvironmentUrls.some((envUrl) => url.includes(envUrl))) {
            envCode = 'dev';
        } else if (testEnvironmentUrls.some((e) => url.includes(e))) {
            envCode = 'test';
        } else if (stageEnvironmentUrls.some((envUrl) => url.includes(envUrl))) {
            envCode = 'stage';
        } else if (prodEnvironmentUrls.some((envUrl) => url.includes(envUrl))) {
            envCode = 'prod';
        }
    }
    return envCode;
}

module.exports = {
    getEnvironmentCode,
    checkForUrl
};
